export const regexSlashWithoutAdjacentSpace = /(\S)\/(\S)/
